/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled } from "@mui/material";

export const CartColumnView = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: "16px",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const FlexGrow = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FlexShrink = styled("div")`
  flex-shrink: 1;
  gap: 16px;
`;
